export const GENDER_OPTIONS = [
  { value: 1, label: 'Hombre' },
  { value: 2, label: 'Mujer' },
  { value: 3, label: 'Otro' }
];